// import modular routes
import homeRoutes, { noneOverallRoutesHome } from '@modules/home/routes';
import authRoutes from '@modules/auth/routes';
import Purchase from '@modules/purchase/routes';
import widgetRouters from '../modules/widget/routes';
const routers = [...homeRoutes, ...authRoutes, ...Purchase];
const noneOverallRoutes = [...noneOverallRoutesHome, ...widgetRouters];
export { noneOverallRoutes };
export default routers;
